import React, { useState, useEffect } from 'react';
import PageHeader from 'app/components/PageHeader';
import { Box, Button, Divider, Typography } from '@mui/material';
import DocumentIcon from 'app/components/Icons/DocumentIcon';
import {
  additionsBox,
  confirmBox,
  details,
  detailsBox,
  detailsInfo,
  detailsInfoDesc,
  fileBox,
  watchBtn,
} from 'app/pages/TransferPage/TransferConfirmPage.sx';
import logger from 'app/utils/logger';
import { sign } from 'app/pages/TransferPage/TransferPage.sx';
import BookmarkIcon from 'app/components/Icons/BookmarkIcon';
import { useSendToSign } from 'app/utils/services/transferService';
import AsanConfirmation from 'app/components/AsanConfirmation';
import { black1 } from 'app/components/ThemeProvider/colors';
import { chunk } from 'lodash';

import CustomSnackbar from 'app/components/CustomSnackbar';
import SuccessModal from 'app/components/SuccessModal';
import { useOutletContext } from 'react-router-dom';
import SaveTemplate from 'app/components/SaveTemplate';

interface Props {
  data?: any;
  businessKey?: any;
  saveTemplate?: any;
  setSaveTemplate?: any;
  handleSaveTemplate?: any;
  handleChangeTemplateName?: any;
  saveTemplateSuccess?: any;
  setSaveTemplateSuccess?: any;
  pathUrl?: any;
  changeName?: any;
  templateName?: any;
  dataCreateTemplate?: any;
  error?: any;
  setError?: any;
}

const TransferConfirmPage = (props: Props) => {
  const {
    data,
    businessKey,
    setSaveTemplate,
    saveTemplate,
    saveTemplateSuccess,
    handleSaveTemplate,
    handleChangeTemplateName,
    setSaveTemplateSuccess,
    pathUrl,
    changeName,
    templateName,
    dataCreateTemplate,
    setError,
    error,
  } = props;
  const [asanConfirmation, setAsanConfirmation] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [errorModal, setErrorModal] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const { signType } = useOutletContext<{ signType: any }>();

  const { isLoadingSendToSign, sendToSignMutation, dataSendToSign } = useSendToSign();

  const handleSendToSign = () => {
    sendToSignMutation({ businessKey, data: { form_id: 'save_to_sign' } });
  };
  const handleSign = () => {
    sendToSignMutation({ businessKey, data: { form_id: 'sign' } });
  };

  useEffect(() => {
    if (dataSendToSign?.form_id === 'asan_wait_popup' || dataSendToSign?.form_id === 'otp') {
      setAsanConfirmation(true);
    }
    else if (dataSendToSign?.error !== undefined) {
      setOpenSnackbar(true);
    } else if (dataSendToSign?.form_id === 'success_action') {
      setSuccessModal(true);
    } else if (dataSendToSign?.form_id === 'error') {
      setErrorModal(true);
    }
  }, [dataSendToSign]);

  return (
    <>
      <PageHeader pageName={'Əməliyyatın təsdiqi'} back={true} editTemplate={false} showBtnBox={true} />
      <Box sx={confirmBox}>
        {data?.details.map((innerArray: any, index: any) => (
          <Box key={index}>
            <Box sx={detailsBox}>
              {innerArray.map((obj: any, innerIndex: any) => (
                <Box sx={details} key={innerIndex}>
                  <Typography sx={detailsInfoDesc}>{obj.title}</Typography>
                  <Typography sx={detailsInfo}>{obj.value}</Typography>
                </Box>
              ))}
            </Box>
            <Divider sx={{ m: '28px 0' }} />
          </Box>
        ))}
        {(data?.description !== undefined || data?.description.length > 0) && (
          <Box sx={{ ...details, width: '80%' }}>
            <Typography sx={detailsInfoDesc}>Təyinat</Typography>
            <Box
              component={'pre'}
              sx={{ ...detailsInfo, color: 'rgba(20, 25, 31, 0.80)', fontWeight: 400, fontFamily: 'Yelo' }}
            >
              {data?.description}
            </Box>
          </Box>
        )}
        {data?.files !== undefined && data?.files.length > 0 && (
          <Box sx={additionsBox}>
            <Typography sx={detailsInfoDesc}>Əlavələr</Typography>
            {data?.files.map((item: any, index: any) => (
              <Box sx={fileBox} key={index}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                  <DocumentIcon />
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
                    <Typography sx={{ lineHeight: '1', fontWeight: '500' }}>{item.file_name}</Typography>
                    <Typography sx={{ lineHeight: '1', fontSize: '12px', color: 'rgba(20, 25, 31, 0.60)' }}>
                      {item.size}
                    </Typography>
                  </Box>
                </Box>
                {/*<Button color={'tertiary'}>*/}
                <a href={`${item.url}`} style={watchBtn} target="_blank" rel="noreferrer">
                  Fayla bax
                </a>
                {/*</Button>*/}
              </Box>
            ))}
          </Box>
        )}
        {data?.edv_details !== undefined && (
          <Box sx={{ mt: '28px' }}>
            <Typography sx={detailsInfoDesc}>18% ƏDV üçün ödəniş məlumatları</Typography>
            <Box
              sx={{
                border: '1px solid rgba(20, 25, 31, 0.2)',
                borderRadius: '8px',
                p: '28px',
                mt: '16px',
                display: 'flex',
                gap: '32px',
                flexWrap: 'wrap',
              }}
            >
              {chunk(data?.edv_details, 2).map((item: any, index: any) => (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }} key={index}>
                  {item.map((innerItem: any, innerIndex: any) => (
                    <Box key={innerIndex}>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <Typography sx={{ fontSize: '16px', color: 'rgba(20, 25, 31, 0.60)', lineHeight: '1' }}>
                          {innerItem.title}
                        </Typography>
                        <Typography sx={{ fontSize: '20px', color: black1, lineHeight: '1', fontWeight: '600' }}>
                          {innerItem.value}
                        </Typography>
                      </Box>
                    </Box>
                  ))}
                </Box>
              ))}
            </Box>
          </Box>
        )}
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: data?.buttons.includes('save_template') ? 'space-between' : 'flex-end',
          mt: '28px',
        }}
      >
        {data?.buttons.includes('save_template') && (
          <Button sx={{ display: 'flex', gap: '12px' }} color={'secondary'} onClick={() => setSaveTemplate(true)}>
            <BookmarkIcon color={'warning'} />
            Şablon kimi yadda saxla
          </Button>
        )}

        <Box sx={{ display: 'flex', gap: '12px' }}>
          {data?.buttons.includes('save_to_sign') && (
            <Button color={'secondary'} onClick={handleSendToSign}>
              İmzaya göndər
            </Button>
          )}
          <AsanConfirmation
            open={asanConfirmation}
            close={setAsanConfirmation}
            verifyCode={dataSendToSign?.verification_code}
            timerTime={dataSendToSign?.timer}
            pathUrl={dataSendToSign?.path_url}
            businessKey={dataSendToSign?.business_key}
          />
          {data?.buttons.includes('sign') && (
            <Button sx={sign} onClick={handleSign}>
              İmzala
            </Button>
          )}
        </Box>
      </Box>
      {dataSendToSign?.error !== undefined && dataSendToSign?.error?.text.length > 0 && (
        <CustomSnackbar
          open={openSnackbar}
          setOpen={setOpenSnackbar}
          hideDuration={5000}
          type={dataSendToSign?.error.type}
          text={dataSendToSign.error.text}
        />
      )}
      {successModal && (
        <SuccessModal
          successText={'Ödəniş uğurla imzaya göndərildi!'}
          open={successModal}
          close={setSuccessModal}
          sign={true}
        />
      )}
      {errorModal && (
        <SuccessModal
          open={errorModal}
          close={setErrorModal}
          successText={'Uğursuz əməliyyat'}
          unsuccess={true}
          sign={false}
        />
      )}
      <SaveTemplate
        open={saveTemplate}
        close={setSaveTemplate}
        save={handleSaveTemplate}
        changeName={changeName}
        templateName={templateName}
        successModal={saveTemplateSuccess}
        setSuccessModal={setSaveTemplateSuccess}
        pathUrl={pathUrl}
        dataCreateTemplate={dataCreateTemplate}
        error={error}
        setError={setError}
      />
    </>
  );
};

export default TransferConfirmPage;
